import { render, staticRenderFns } from "./ghacBanner2.vue?vue&type=template&id=ce352abe&"
import script from "./ghacBanner2.vue?vue&type=script&lang=js&"
export * from "./ghacBanner2.vue?vue&type=script&lang=js&"
import style0 from "./ghacBanner2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports